export const AdditionalAddressKeys: string[] = ['street_number', 'street_name', 'suburb', 'city', 'district', 'province', 'country', 'longitude', 'latitude'];
